export const listar = (pag, listado) => {
    let lista = listado.slice(2 * pag -2, 2 * pag);
    return lista
}

